module.exports = __webpack_public_path__ + "img/invoices-icon-blue.095f9b03.svg";